const getters = {
    projectCosts: (state) => state.projectCosts,
    projectCost: (state) => state.projectCost,
    loading: (state) => state.loading,
};

export default getters;
